import DeleteSegmentConfirmationModal from './DeleteSegmentConfirmationModal';
import EditSegmentModal from './EditSegmentModal';
import SavedSegmentModal from './SavedSegmentsModal';

export { DeleteSegmentConfirmationModal, EditSegmentModal };

export default SavedSegmentModal;
